import React, { useEffect, useContext, useState, useRef } from "react";
import { toast } from "react-toastify";
import {
  SD_Right_Arrow_white,
} from "../../../Assets/imageList";
import { SD_Context } from "../../../context/sd-context";
import Sd_DashboardService from "../../../services/sd-dashboard.service";
import "../../../Utils/sd-styles/sd-css/main.css";
import "react-toastify/dist/ReactToastify.css";

import Sd_loading from "../../../Components/sd-common-components/sd-loading";
import ParokshaSevaService from "../../../services/sd-parokshaseva.service";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";

import moment from "moment";
const Sd_dashboard_e_hundi = ({ history }) => {
  //-------------------------------------------------------------states--------------------------------------------------------//
  const {
    setActive,
    setActivePath,
    currentBookingDonation,
    setcurrentBookingDonation,
    userData,
    devoteeList,
    logout,
  } = useContext(SD_Context);

  const [donor, setDonar] = useState("");
  const [gothram, setGothram] = useState("");
  const [occasion, setOcassion] = useState("");
  const [amount, setAmount] = useState("");
  const [autoFill, setAutoFill] = useState("none");
  const [selectArray, setSelectArray] = useState([]);
  const supportedLanguages = ["en-in", "jp-in", "de-in", "es-in"];
  const [loading, setloading] = useState(true);
  const [selectedLanguage, setSelectedlanguage] = React.useState("en-in");
  const [acceptFlag, setAcceptFlag] = useState(false);
  const [donation, setDonation] = useState(null);
  const [err, setErr] = useState([]);
  const ref = useRef(null);
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("India");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [mobile, setMobile] = useState("91");
  const AddressRegex = /^[#.0-9a-zA-Z\s,-/]+$/;
  const templeID = process.env.REACT_APP_TEMPLE ?? "SBMSD";
  //-------------------------------------------------------------states-----------------------------------------------------------//

  //-------------------------------------------------------------useeffect--------------------------------------------------------//
  useEffect(() => {
    setloading(true);
    setActive("e-hundi");
    setActivePath("E-Hundi");
    if (
      new URLSearchParams(history?.location?.search).get("state") === "clear"
    ) {
      setcurrentBookingDonation(null);
    }
    if (
      supportedLanguages.includes(
        history?.location?.pathname?.split?.("/")?.[1]
      )
    ) {
      setSelectedlanguage(history?.location?.pathname?.split?.("/")?.[1]);
    } else {
      setSelectedlanguage("en-in");
    }
    localStorage.removeItem("payment-context");

    getData();
  }, []);

  //-------------------------------------------------------------useeffect--------------------------------------------------------//

  //-------------------------------------------------------------functions-----------------------------------------------------------//
  const getData = async () => {
    try {
      let res = await Sd_DashboardService.donations_getall(templeID);
      // Filter for e-Hundi only
      let eHundiDonation = res.find(
        (item) => item?.name?.toLowerCase() === "e-hundi"
      );
      if (eHundiDonation) {
        setDonation(eHundiDonation);
        setSelectArray([eHundiDonation]);
      }

      if (currentBookingDonation) {
        setDonar(currentBookingDonation?.donor);
        setGothram(currentBookingDonation?.gothram);
        setDonation(currentBookingDonation?.donation);
        setAmount(currentBookingDonation?.amount);
        currentBookingDonation?.occasion &&
          setOcassion(currentBookingDonation?.occasion);
        setGothram(currentBookingDonation?.gothram);
        setAddress1(currentBookingDonation?.address1);
        setAddress2(currentBookingDonation?.address2);
        setCountry(currentBookingDonation?.country);
        setState(currentBookingDonation?.state);
        setCity(currentBookingDonation?.city);
        setZip(currentBookingDonation?.zip);
        setMobile(currentBookingDonation?.mobile);
        setAcceptFlag(false);
      }

      setloading(false);
    } catch (e) {
      toast.warning(e.message);
      if (e.message === "Session Expired") {
        logout();

        history?.push(
          `/${selectedLanguage}/devotee/signin?to=devotee-app/e-hundi`
        );
      }
      setloading(false);
    }
  };

  function capitalize(str) {
    let splitStr = str?.toLowerCase?.().split?.(" ");
    for (let i = 0; i < splitStr?.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr?.join(" ");
  }

  const handleSubmit = async () => {
    setloading(true);
    let a = true;

    if (a) {
      let data = [...err];
      if (address1 === "") {
        data.push({ type: "address1", msg: "Please enter a valid address" });
      } else if (address1.length < 3) {
        data.push({ type: "address1", msg: "Minimum 3 characters" });
      }
      if (mobile.substring(0, 2) === "91") {
        if (mobile.length !== 12) {
          data.push({ type: "phone", msg: "Invalid mobile number" });
        }
      } else {
        if (mobile.length < 8) {
          data.push({ type: "phone", msg: "Invalid mobile number" });
        }
      }
      if (city === "") {
        data.push({ type: "city", msg: "Please enter a city" });
      } else if (city.length < 3) {
        data.push({ type: "city", msg: "Minimum 3 characters" });
      }
      if (state === "") {
        data.push({ type: "state", msg: "Please select your state" });
      }

      if (zip.length === "") {
        data.push({ type: "zip", msg: "Invalid zipcode! Try again" });
      }
      if (country === "") {
        data.push({ type: "country", msg: "Please select a country" });
      }

      if (donation === null || donation === "") {
        data.push({ type: "type", msg: "Donation type is required" });
      }

      if (amount === "") {
        data.push({ type: "amount", msg: "Please enter a donation amount" });
      } else {
        if (amount < donation?.min_amount || amount < 1) {
          data.push({
            type: "amount",
            msg: `Minimum donation amount is Rs. ${donation?.min_amount || 1}`,
          });
        }
      }

      if (donor === "") {
        data.push({ type: "donor", msg: "Please enter a donor/nominee name" });
      } else if (donor.length < 3) {
        data.push({ type: "donor", msg: "Name must be minimum 3 characters" });
      }

      if (acceptFlag === false) {
        data.push({
          type: "acceptFlag",
          msg: "Please accept terms and conditions",
        });
      }

      setErr(data);
      if (data.length !== 0) {
        setloading(false);
        ref.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        return;
      }
    }

    try {
      let dto = {
        donationId: Number(donation?.id),
        devoteeName: donor,
        amount: Number(amount),
        address: capitalize(address1),
        city: capitalize(city),
        state: state,
        country: country,
        pinCode: Number(zip),
        contact: `+${mobile}`,
      };

      if (gothram !== "") {
        dto.gothram = capitalize(gothram);
      }
      if (address2 !== "") {
        dto.address2 = capitalize(address2);
      }
      if (occasion) {
        dto.occasion = capitalize(occasion);
      }

      let subDataObj = {
        cartContains: ["donation"],
        donationBookings: [dto],
        returnPriceStats: true,
      };

      let res = await ParokshaSevaService.bookings(subDataObj, templeID);

      if (res) {
        let data = {
          donor,
          gothram,
          amount,
          donation,
          address1,
          address2,
          city,
          country,
          state,
          zip,
          mobile,
          res,
          templeID,
        };
        if (occasion !== "") {
          data.occasion = capitalize(occasion);
        }

        setcurrentBookingDonation(data);

        history?.push(
          `/${selectedLanguage}/devotee-app/e-hundi/confirm`
        );
      }
    } catch (e) {
      ref.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      toast.error(e.message);
      if (e.message === "Session Expired") {
        logout();
        history?.push(
          `/${selectedLanguage}/devotee/signin?to=devotee-app/e-hundi`
        );
      }
      setloading(false);

      return;
    }
  };

  const autoFillFunction = (name) => {
    let array = [];

    const userCLick = () => {
      userData?.firstName || userData?.lastName
        ? setDonar(`${userData?.firstName} ${userData?.lastName}`)
        : setDonar(userData?.displayName);
      userData?.gothram ? setGothram(userData?.gothram) : setGothram("");

      userData?.city ? setCity(userData?.city) : setCity("");
      userData?.country && setCountry(userData?.country);
      userData?.address1 ? setAddress1(userData?.address1) : setAddress1("");
      userData?.address2 ? setAddress2(userData?.address2) : setAddress2("");
      userData?.state ? setState(userData?.state) : setState("");
      userData?.phone
        ? setMobile(userData?.phone?.replace?.("+", ""))
        : setMobile("");
      userData?.pinCode ? setZip(userData?.pinCode) : setZip("");
      let data = err.filter((e) => {
        if (
          e.type !== "donor" &&
          e.type !== "gothram" &&
          e.type !== "city" &&
          e.type !== "address1" &&
          e.type !== "state" &&
          e.type !== "country" &&
          e.type !== "phone" &&
          e.type !== "zip" &&
          e.type !== "address2"
        ) {
          return e;
        }
      });
      setErr(data);

      setAutoFill("none");
    };
    if (
      userData?.firstName?.toLowerCase()?.includes(name?.toLowerCase()) ||
      userData?.lastName?.toLowerCase()?.includes(name?.toLowerCase())
    ) {
      array.push(
        <p
          className="sd-autofill-div"
          onClick={() => {
            userCLick();
          }}
        >
          <p
            style={{ textTransform: "capitalize" }}
            onClick={() => {
              userCLick();
            }}
          >
            Name:{" "}
            {userData?.firstName ? userData?.firstName : userData?.displayName}
            <span style={{ marginLeft: "3px" }}>{userData?.lastName}</span>
          </p>
        </p>
      );
    }
    if (devoteeList !== null) {
      devoteeList.forEach((items) => {
        if (
          items?.firstName?.toLowerCase()?.includes(name?.toLowerCase()) ||
          items?.lastName?.toLowerCase()?.includes(name?.toLowerCase())
        ) {
          const onClicks = () => {
            items?.firstName || items?.lastName
              ? setDonar(`${items?.firstName} ${items?.lastName}`)
              : setDonar("");
            items?.gothram ? setGothram(items?.gothram) : setGothram("");
            let data = err.filter((e) => {
              if (
                e.type !== "donor" &&
                e.type !== "gothram"
              ) {
                return e;
              }
            });
            setErr(data);
            setAutoFill("none");
          };
          array.push(
            <p
              key={items.id + "autofill"}
              className="sd-autofill-div"
              onClick={() => {
                onClicks();
              }}
            >
              <p
                onClick={() => {
                  onClicks();
                }}
              >
                Name: {items?.firstName}
                <span style={{ marginLeft: "3px" }}>{items?.lastName}</span>
              </p>
            </p>
          );
        }
      });
    }

    if (array.length !== 0) {
      return (
        <div className="sd-autofill bg">
          {array.map((item) => {
            return item;
          })}
        </div>
      );
    } else {
      if (name === "") {
        let demo = (
          <p
            className="sd-autofill-div"
            onClick={() => {
              userCLick();
            }}
          >
            <p
              style={{ textTransform: "capitalize" }}
              onClick={() => {
                userCLick();
              }}
            >
              Name:{" "}
              {userData?.firstName
                ? userData?.firstName
                : userData?.displayName}
              <span style={{ marginLeft: "3px" }}>{userData?.lastName}</span>
            </p>
          </p>
        );

        let a = [...devoteeList, demo];
        return (
          <div className="sd-autofill bg">
            {a.map((item) => {
              return item;
            })}{" "}
          </div>
        );
      } else {
        return "";
      }
    }
  };
  //-------------------------------------------------------------functions--------------------------------------------------------//
  return (
    <>
      {loading ? (
        <Sd_loading dist="67%" />
      ) : (
        <div
          className="col-xs-12 col-sm-12 col-md-9 col-lg-9 sd-dashboard"
          style={{
            minHeight: document.getElementById("side-menu")?.offsetHeight,
          }}
        >
          <div className="col-xs-12 col-sm-12 col-md-11 col-lg-10 pl-0 xs-pr-0 sd-profile sd-seva-form">
            <h2 className="sd-side-heading fw400">
              <span className="fw700">E-Hundi</span>
            </h2>
            <div className="clearfix">
              <form className="sd-form">
                <div className="clearfix">
                  <div className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6  xssm-pr-0 pl-0">
                    <label ref={ref}>
                      Donor / Nominee Name<span className="sd-imp">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Please enter a donor/nominee name"
                      value={donor}
                      maxLength="30"
                      className={
                        err?.find((e) => e.type === `donor`)
                          ? "form-control sd-red"
                          : donor !== ""
                          ? "form-control sd-voilet"
                          : "form-control"
                      }
                      onFocus={() => {
                        if (autoFill === `autofill`) {
                          setAutoFill("none");
                        } else {
                          setAutoFill(`autofill`);
                        }
                      }}
                      onBlur={() => {
                        if (autoFill === `autofill`) {
                          setTimeout(() => {
                            setAutoFill("none");
                          }, 200);
                        }
                      }}
                      onChange={(e) => {
                        if (
                          /^[a-zA-Z ]*$/.test(String(e.target.value)) ||
                          e.target.value === ""
                        ) {
                          if (err.find((e) => e.type === "donor")) {
                            let data = err.filter((e) => e.type !== "donor");
                            setErr(data);
                          }
                          setDonar(e.target.value);
                        }
                      }}
                    />
                    {autoFill === `autofill` && autoFillFunction(donor)}

                    <p className="d-EM mr-15">
                      {err.find((e) => e.type === "donor")?.msg}
                    </p>
                  </div>
                  <div className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6  xssm-pl-0 xssm-pr-0  pr-0">
                    <label>Gothram</label>
                    <input
                      type="text"
                      maxLength="30"
                      placeholder="Please enter your gothram."
                      className={
                        err?.find((e) => e.type === `gothram`)
                          ? "form-control sd-red"
                          : gothram !== ""
                          ? "form-control sd-voilet"
                          : "form-control"
                      }
                      value={gothram}
                      onChange={(e) => {
                        if (
                          /^[a-zA-Z]*$/.test(String(e.target.value)) ||
                          e.target.value === ""
                        ) {
                          if (err.find((e) => e.type === "gothram")) {
                            let data = err.filter((e) => e.type !== "gothram");
                            setErr(data);
                          }
                          setGothram(e.target.value);
                        }
                      }}
                    />
                    <p className="d-EM">
                      {err.find((e) => e.type === "gothram")?.msg}
                    </p>
                  </div>
                </div>
                <div className="clearfix">
                  <div className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6  xssm-pr-0 pl-0">
                    <label>
                      Amount<span className="sd-imp">*</span>
                    </label>
                    <input
                      type="number"
                      maxLength="6"
                      onWheel={(event) => event.currentTarget.blur()}
                      className={
                        err?.find((e) => e.type === `amount`)
                          ? "form-control sd-red"
                          : amount !== ""
                          ? "form-control sd-voilet"
                          : "form-control"
                      }
                      style={{ textTransform: "none" }}
                      placeholder={`Minimum donation amount Rs. ${
                        donation?.price !== undefined ? donation?.price : 1
                      }`}
                      value={amount}
                      onChange={(e) => {
                        if (err.find((e) => e.type === "amount")) {
                          let data = err.filter((e) => e.type !== "amount");
                          setErr(data);
                        }
                        setAmount(e.target.value);
                      }}
                    />

                    <p className="d-EM mr-15">
                      {err.find((e) => e.type === "amount")?.msg}
                    </p>
                  </div>
                  <div className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6  xssm-pl-0 xssm-pr-0  pr-0">
                    <label>Occasion / Auspicious Day</label>
                    <input
                      type="text"
                      maxLength="30"
                      placeholder="Please enter the occasion. Eg: Birthday"
                      className={
                        occasion !== ""
                          ? "form-control sd-voilet"
                          : "form-control"
                      }
                      value={occasion}
                      onChange={(e) => {
                        if (
                          AddressRegex.test(e.target.value) ||
                          e.target.value === ""
                        ) {
                          setOcassion(e.target.value);
                        }
                      }}
                    />
                  </div>
                </div>
                <hr className="clearfix"></hr>
                <div className="clearfix">
                  <div className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6  xssm-pr-0 pl-0">
                    <label>
                      Address Lane 1<span className="sd-imp">*</span>
                    </label>
                    <input
                      type="text"
                      maxLength="50"
                      placeholder="House/building number, street number"
                      className={
                        err.find((e) => e.type === "address1")
                          ? "form-control sd-red"
                          : address1 !== ""
                          ? "form-control sd-voilet"
                          : "form-control"
                      }
                      value={address1}
                      onChange={(e) => {
                        if (
                          AddressRegex.test(e.target.value) ||
                          e.target.value === ""
                        ) {
                          if (
                            err.find(
                              (e) =>
                                e.type === "address1" || e.type === "common"
                            )
                          ) {
                            let data = err.filter((e) => {
                              if (
                                e.type !== "address1" &&
                                e.type !== "common"
                              ) {
                                return e;
                              }
                            });
                            setErr(data);
                          }
                          setAddress1(e.target.value);
                        }
                      }}
                    />
                    <p className="d-EM mr-15">
                      {err.find((e) => e.type === "address1")
                        ? err.find((e) => e.type === "address1")?.msg
                        : ""}
                    </p>
                  </div>
                  <div className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6  xssm-pl-0  xssm-pr-0 pr-0 ">
                    <label>Address Lane 2</label>
                    <input
                      type="text"
                      maxLength="50"
                      className={
                        err.find((e) => e.type === "address2")
                          ? "form-control sd-red"
                          : address2 !== ""
                          ? "form-control sd-voilet"
                          : "form-control"
                      }
                      placeholder="building name, street name, etc"
                      value={address2}
                      onChange={(e) => {
                        if (
                          AddressRegex.test(e.target.value) ||
                          e.target.value === ""
                        ) {
                          if (
                            err.find(
                              (e) =>
                                e.type === "address2" || e.type === "common"
                            )
                          ) {
                            let data = err.filter((e) => {
                              if (
                                e.type !== "address2" &&
                                e.type !== "common"
                              ) {
                                return e;
                              }
                            });
                            setErr(data);
                          }
                          setAddress2(e.target.value);
                        }
                      }}
                    />
                    <p className="d-EM mr-15">
                      {err.find((e) => e.type === "address2")
                        ? err.find((e) => e.type === "address2")?.msg
                        : ""}
                    </p>
                  </div>
                </div>
                <div className="clearfix">
                  <div className="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3  xssm-pr-0 pl-0">
                    <label>
                      City<span className="sd-imp">*</span>
                    </label>
                    <input
                      type="text"
                      maxLength="30"
                      className={
                        err.find((e) => e.type === "city")
                          ? "form-control sd-red"
                          : city !== ""
                          ? "form-control sd-voilet"
                          : "form-control"
                      }
                      value={city}
                      placeholder="Please enter your city"
                      onChange={(e) => {
                        if (
                          AddressRegex.test(e.target.value) ||
                          e.target.value === ""
                        ) {
                          if (
                            err.find(
                              (e) => e.type === "city" || e.type === "common"
                            )
                          ) {
                            let data = err.filter((e) => {
                              if (e.type !== "city" && e.type !== "common") {
                                return e;
                              }
                            });
                            setErr(data);
                          }
                          setCity(e.target.value);
                        }
                      }}
                    />
                    <p className="d-EM mr-15">
                      {err.find((e) => e.type === "city")
                        ? err.find((e) => e.type === "city")?.msg
                        : ""}
                    </p>
                  </div>

                  <div className="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3  xssm-pr-0 ">
                    <label>
                      Zipcode<span className="sd-imp">*</span>
                    </label>
                    <input
                      type="text"
                      onWheel={(event) => event.currentTarget.blur()}
                      className={
                        err.find((e) => e.type === "zip")
                          ? "form-control sd-red"
                          : zip !== ""
                          ? "form-control sd-voilet"
                          : "form-control"
                      }
                      value={zip}
                      maxLength={12}
                      placeholder="Enter your zipcode"
                      onChange={(e) => {
                        if (
                          AddressRegex.test(e.target.value) ||
                          e.target.value === ""
                        ) {
                          if (
                            err.find(
                              (e) => e.type === "zip" || e.type === "common"
                            )
                          ) {
                            let data = err.filter((e) => {
                              if (e.type !== "zip" && e.type !== "common") {
                                return e;
                              }
                            });
                            setErr(data);
                          }
                          if (e.target.value.length < 12) {
                            setZip(e.target.value.toUpperCase());
                          }
                        }
                      }}
                    />
                    <p className="d-EM mr-15">
                      {err.find((e) => e.type === "zip")
                        ? err.find((e) => e.type === "zip")?.msg
                        : ""}
                    </p>
                  </div>

                  <div className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6  xssm-pr-0 pr-0 ">
                    <label>
                      State<span className="sd-imp">*</span>
                    </label>
                    <RegionDropdown
                      country={country}
                      classes={
                        err.find((e) => e.type === "state")
                          ? "sd-red w-100 sd-border-none"
                          : state !== ""
                          ? " sd-voilet w-100 sd-border-none"
                          : "w-100 sd-border-none"
                      }
                      value={state}
                      showDefaultOption={true}
                      blankOptionLabel="Select a State"
                      onChange={(val) => {
                        if (
                          err.find(
                            (e) => e.type === "state" || e.type === "common"
                          )
                        ) {
                          let data = err.filter((e) => {
                            if (e.type !== "state" && e.type !== "common") {
                              return e;
                            }
                          });
                          setErr(data);
                        }
                        setState(val);
                      }}
                    />
                    <p className="d-EM ">
                      {err.find((e) => e.type === "state")
                        ? err.find((e) => e.type === "state")?.msg
                        : ""}
                    </p>
                  </div>
                </div>
                <div className="clearfix">
                  <div className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6  xssm-pl-0 pl-0 xssm-pr-0 ">
                    <label>
                      Country<span className="sd-imp">*</span>
                    </label>
                    <CountryDropdown
                      value={country}
                      classes={
                        err.find((e) => e.type === "country")
                          ? "sd-red w-100 "
                          : country !== ""
                          ? " sd-voilet w-100 sd-border-none"
                          : "w-100 sd-border-none"
                      }
                      showDefaultOption={true}
                      defaultValue="India"
                      defaultOptionLabel="Select a Country"
                      onChange={(val) => {
                        if (
                          err.find(
                            (e) => e.type === "country" || e.type === "common"
                          )
                        ) {
                          let data = err.filter((e) => {
                            if (e.type !== "country" && e.type !== "common") {
                              return e;
                            }
                          });
                          setErr(data);
                        }
                        setCountry(val);
                      }}
                    />
                    <p className="d-EM mr-15">
                      {err.find((e) => e.type === "country")
                        ? err.find((e) => e.type === "country")?.msg
                        : ""}
                    </p>
                  </div>

                  <div className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6  xssm-pr-0 pr-0">
                    <label>
                      Mobile Number<span className="sd-imp">*</span>
                    </label>

                    <div className={"sd-profile-mobile"}>
                      <PhoneInput
                        inputExtraProps={{
                          autoFocus: true,
                          enableSearch: true,
                          countryCodeEditable: false,
                        }}
                        onlyCountries={["in"]}
                        placeholder="Enter Your 10 digit mobile number"
                        maxLength="15"
                        countryCodeEditable={false}
                        containerClass={
                          err?.find((e) => e.type === "phone")
                            ? "sd-phone-voilet sd-red"
                            : mobile !== ""
                            ? "sd-phone-voilet"
                            : ""
                        }
                        country="in"
                        value={mobile}
                        onChange={(e) => {
                          if (
                            err?.find(
                              (e) => e.type === "phone" || e.type === "common"
                            )
                          ) {
                            let array = err.filter((e) => {
                              if (e.type !== "phone" && e.type !== "common") {
                                return e;
                              }
                            });
                            setErr(array);
                          }
                          setMobile(e);
                        }}
                      />
                      <p className="d-EM ">
                        {err.find((e) => e.type === "phone")
                          ? err.find((e) => e.type === "phone")?.msg
                          : ""}
                      </p>
                    </div>
                  </div>
                </div>

                <hr className="clearfix"></hr>
                <div className="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12  xssm-pl-0 pr-0">
                  <ol className="sd-terms-list">
                    <li>
                      Srisailam Devasthanam is an Endowment Organisation
                      which supervises the administrative functions
                      necessary to conduct the various traditional rituals
                      at Srisaila Devasthanam, Srisailam.
                    </li>
                    <li>
                      Srisailam Devasthanam  does not solicit or canvass for
                      any offering. Srisaila Devasthanam has its own fund,
                      the corpus of which, shall include all the amounts
                      received by it, by way of offerings, including
                      offerings deposited in e-Hundi.
                    </li>
                  </ol>

                  <div className="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 xssm-pr-0 pl-0 sd-terms-checkbox">
                    <input
                      type="checkbox"
                      name=""
                      value={acceptFlag}
                      onChange={() => {
                        if (err.find((e) => e.type === "acceptFlag")) {
                          let data = err.filter((e) => e.type !== "acceptFlag");
                          setErr(data);
                        }
                        setAcceptFlag(!acceptFlag);
                      }}
                      checked={acceptFlag ? true : false}
                    />
                    <label
                      htmlFor=""
                      style={{ marginBottom: "0px" }}
                      className="ml-5"
                    >
                      I agree to the{" "}
                      <a
                        onClick={() => {
                          history?.push(
                            `/${selectedLanguage}/legalities/terms-and-conditions`
                          );
                        }}
                      >
                        Terms & Conditions
                      </a>{" "}
                      and the
                      <a
                        style={{ marginLeft: "3px" }}
                        onClick={() => {
                          history?.push(
                            `/${selectedLanguage}/legalities/privacy-policy`
                          );
                        }}
                      >
                        Privacy Policy
                      </a>
                    </label>
                    <p className="sd-accept">
                      {err.find((e) => e.type === "acceptFlag")?.msg}
                    </p>
                  </div>
                </div>
                <hr className="clearfix"></hr>
                <div className="clearfix mt-50">
                  <a
                    className="sd-btn-orange"
                    onClick={() => {
                      if (!loading) {
                        handleSubmit();
                      }
                    }}
                  >
                    Continue
                    <img
                      className="sd-arrow-btn ml-5"
                      src={SD_Right_Arrow_white}
                    />
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Sd_dashboard_e_hundi;

